if(typeof String.prototype.trim !== 'function') {
	String.prototype.trim = function() {
		return this.replace(/^\s+|\s+$/g, '');
	}
}
if(typeof Array.prototype.indexOf !== 'function') {
	Array.prototype.indexOf = function(obj, start) {
		for (var i = (start || 0), j = this.length; i < j; i++) {
			if (this[i] === obj) { return i; }
		}
		return -1;
	}
}
// Klikk.no toolbox

var klikk = (function($){
    var globals = {
            defer: new $.Deferred(),
            facebook: {},
            scrollCallbacks: [],
            social: {
                ajaxCounter: 0,
                user: {},
                gettingUserData: false,
                iframeReloads: 0
            }
        },   // Global variables
        fn = {};        // Functions object

    fn.facebook = {
        teaser: {
            init: function(){
                if(!("art" === globals.publication.context && !globals.article.published)) {
                    getComments = $.Deferred();
                    getComments.done(function(data, e){
                        var teaser = $(".klikk_commentsTeaser");
                        if(e === "success"){
                            var comments = data.data;
                            if(comments.length > 0){
                                var teaserContent = teaser.find(".firstComment");
                                var message = comments[comments.length-1].message;
                                teaserContent.find(".comment").text(message.length > 110 ? message.substr(0, 109) + "..." : message);
                                if(typeof comments[comments.length-1].from !== "undefined" && typeof comments[comments.length-1].from.name !== "undefined")
                                    teaserContent.find(".name").text(comments[comments.length-1].from.name);
                                teaser.find(".klikk_commentsCount").text(comments.length).parent().show();
                                teaserContent.toggle();
                            } else {
                                teaser.find(".default").toggle();
                                teaser.find(".klikk_commentsCount").text("0").parent().show();
                            }
                        } else {
                            teaser.find(".default").toggle();
                            teaser.find(".klikk_commentsCount").parent().show();
                        }
                    });

                    fn.facebook.getComments();
                }
            }
        },
        comments: {
            init: function(numberOfComments){
                if(!("art" === globals.publication.context && !globals.article.published)) {
                    getComments = $.Deferred();
                    getComments.done(function (data, e) {
                        if (e === "success") {
                            if ( data.data.length > 0 ) {
                                if ( data.data.length == 1 ) {
                                    $('#comments-count').html('1 kommentar');
                                } else {
                                    $('#comments-count').html(data.data.length + ' kommentarer');
                                }
                            } else {
                                $('#comments-count').html('Se kommentarer');
                            }
                        }
                    });

                    fn.facebook.getComments();

                    $(function () {
                        fn.facebook.renderComments(numberOfComments);
                    });
                }
                /*
                alert('comments init');
                $(function () {
                    fn.facebook.renderComments(numberOfComments);
                });
                */
            }
        },
	    commentsComplete: {
		    init: function (numberOfComments) {
                if(!("art" === globals.publication.context && !globals.article.published)) {
                    getComments = $.Deferred();
                    getComments.done(function (data, e) {
                        if (e === "success")
                            $('#comments-count').html(data.data.length);
                    });

                    fn.facebook.getComments();

                    $(function () {
                        fn.facebook.renderComments(numberOfComments);
                    });
                }
		    }
	    },
        getComments: function(){
            var url = globals.article.originalUrl.length > 0 ? globals.article.originalUrl : globals.article.url;
            $.ajax({
                url: "//graph.facebook.com/comments/",
                data: {
                    id: url,
                    filter: "stream"
                }
            }).always(function(data, e){
                getComments.resolve(data, e);
            });
        },
        renderComments: function(numberOfComments){
            var comments = $("#facebookCommentsHeight");
            if(!numberOfComments)
                numberOfComments = 10;
            if (comments.is(":empty")) {
                comments.html('<fb:comments href="' + (globals.article.originalUrl.length > 0 ? globals.article.originalUrl : globals.article.url) + '" numposts="' + numberOfComments + '" width="100%"></fb:comments>');
                if (typeof FB !== 'undefined')
                    FB.XFBML.parse(document.getElementById("facebookCommentsHeight"));
            }
        },
        createEvent: function(){
            if(!("art" === globals.publication.context && !globals.article.published)) {
                var facebookAppId = klikk.getGlobal("section.parameters.facebookAppId");
                if (facebookAppId && globals.publication.context === 'art') {
                    window.fbAsyncInit = function () {
                        if (typeof FB !== 'undefined') {
                            FB.Event.subscribe('comment.create', function (response) {
                                var commentQuery = FB.Data.query("SELECT text, fromid FROM comment WHERE post_fbid='" + response.commentID + "' AND object_id IN (SELECT comments_fbid FROM link_stat WHERE url='" + response.href + "')");
                                FB.Data.waitOn([commentQuery], function () {
                                    $.ajax({
                                        url: globals.publication.baseUrl,
                                        data: {
                                            service: "sendMail",
                                            articleId: globals.article.id,
                                            comment: commentQuery.value[0].text
                                        },
                                        context: document.body,
                                        success: function () {
                                        }
                                    });
                                });
                            });
                        }
                    };
                }
            }
        }
    }

    fn.recipe = {
        init: function(){
            if(!this.inited) {
                this.inited = true;
                $(document).ready(function () {
                    $('.embedRecipeButton').click(function () {
                        var embedRecipe = $(this).parents(".recipe").find(".embedRecipe");
                        if (embedRecipe.is(":hidden")) {
                            fn.recipe.createEmbedCode(embedRecipe.find(".createCode"));
                            embedRecipe.find(".createCode").click();
                        }
                        embedRecipe.slideToggle('400');
                    });
                    $('.createCode').click(function () {
                        fn.recipe.createEmbedCode($(this));
                    });
                    $('.embedCode').click(function () {
                        $(this).select();
                    });
                });
            }
        },
        createEmbedCode: function(that){
            var width = that.siblings('#embedSizeWidth').val();
            var height = that.siblings('#embedSizeHeight').val();
            var id = that.parents(".embedRecipe").attr("title");
            if(width >= 400){
                var ads = "true";
                if(width < 530) ads = "false";
                that.siblings('.embedCode').val('<iframe src="//www.klikk.no/index.jsp?service=embedRecipe&recipe='+id+'&ads='+ads+'" id="klikk_recipe" frameborder="0" height="' + height + '" width="' + width + '"></iframe>');
            }else{
                if(!$(".embedError .errorTxt").is(":visible") && $(".recipeContent").find(".embedRecipe").is(":visible")){
                    $(".embedError .errorTxt").fadeIn(200).delay(5000).fadeOut(1000);
                }
            }
        }
    }

    fn.toggle = {
        init: function(){
            if(!this.inited) {
                this.inited = true;
	            $(".relevantArticles.klikk_toggleItem").each(function(){
		           if ( $('article', this).length < 1 ) {
			           $(this).closest('.row').prev('.row').find('.readmore').remove();
		           }
	            });
                $(".klikk_toggleTarget").click(function(e){
                    if (!$(e.target).closest('a').length || $(e.target).parent().hasClass("readmore") || $(e.target).closest(".links").length) {
                        e.preventDefault();
                        var that = $(this);
                        var toggleItemContainer = that.closest(".row").next(".row");
                        var visibleToggleItem = toggleItemContainer.find(".klikk_toggleItem:visible");
                        if(visibleToggleItem.length){
                            var invisibleToggleItem = toggleItemContainer.find(".klikk_toggleItem:hidden");
                            visibleToggleItem.slideToggle(function(){
                                if(!that.hasClass("open")) {
                                    invisibleToggleItem.slideToggle(function(){
                                        if(invisibleToggleItem.hasClass("klikk_refreshImage"))
                                            WFImager.refresh(invisibleToggleItem);
                                    });
                                    $(".klikk_toggleTarget").not(this).removeClass("open").find(".open, .closed").toggle();
                                    that.addClass("open");
                                } else {
                                    that.removeClass("open").find(".open, .closed").toggle();
                                }
                            });
                        } else {
                            if(that.prop("tagName") === "ARTICLE"){
                                var toggleItem = toggleItemContainer.find(".relevantArticles.klikk_toggleItem");
                            }else {
                                var toggleItem = toggleItemContainer.find(".klikk_toggleItem:not(.relevantArticles)");
                            }
                            toggleItem.slideToggle(function(){
                                that.find(".open, .closed").toggle();
                                if(toggleItem.hasClass("klikk_refreshImage"))
                                    WFImager.refresh(toggleItem);
                            });
                            that.addClass("open");
                        }
                    }
                });
            }
        }
    }

    fn.share = {
        init: function(){
            if(!("art" === globals.publication.context && !globals.article.published)) {
                if (!this.inited) {
                    this.w = 646,
                        this.h = 368,
                        this.top = (screen.height / 2) - (this.h / 2),
                        this.left = (screen.width / 2) - (this.w / 2);
                    if (globals.article) {
                        var articleShareUrl = globals.article.originalUrl.length > 0 ? globals.article.originalUrl : globals.article.url,
                            articleShareTitle = globals.article.title;
                    }

                    $(document).on("click", "[data-action^=share_]", function (e) {
                        var that = $(this);
                        var shareUrl = that.data("url"),
                            shareTitle = that.data("title");
                        if (!shareUrl) {
                            if (articleShareUrl) {
                                shareUrl = articleShareUrl;
                                shareTitle = articleShareTitle;
                            } else if (globals.topic) {
                                shareUrl = globals.topic.url;
                                shareTitle = "Alt du vil vite om " + globals.topic.topic + " på Klikk.no";
                            }
                        }
                        var type = that.data("action").split("_")[1];
                        switch (type) {
                            case "facebook":
                                fn.share.shareDialog(shareUrl, shareTitle);
                                break;
                            case "twitter":
                                fn.share.tweetDialog(shareUrl, shareTitle);
                                break;
                            case "googleplus":
                                fn.share.googlePlusDialog(shareUrl);
                                break;
                            case "email":
                                fn.share.emailShare(shareUrl, shareTitle);
                                break;
                            case "facebook-feed":
                                var title = that.data('title');
                                var description = that.data('description');
                                var image = that.data('image');
                                var caption = that.data('caption') || null;
                                fn.share.feedDialog( shareUrl, title, description, image, caption );
                                break;
                        }
                        e.preventDefault();
                    });

                    $(window).load(function () {
                        $.each($(".shareCount:not(.ignore)"), function () {
                            fn.share.setCount($(this));
                        });
                    });
                }
                this.inited = true;
            }
        },
        tweetDialog : function(url, title){
            var modalUrl = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + "&text=" + encodeURIComponent(title.replace(/%22/g, '"'));
            window.open(modalUrl, 'twitterTweetDialog', 'width=' + this.w + ', height=' + this.h + ', top=' + this.top + ', left=' + this.left);
        },
        shareDialog : function(url, title){
            var modalUrl = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(url);
            window.open(modalUrl, 'facebookShareDialog', 'width=' + this.w + ', height=' + this.h + ', top=' + this.top + ', left=' + this.left);
        },
        feedDialog: function ( url, title, description, image, caption ) {
            FB.ui({
                method: 'feed',
                link: url,
                name: title,
                description: description,
                caption: caption,
                picture: image
            }, function ( response ) {
                // Do nothing
            });

        },
        googlePlusDialog : function ( url ) {
            var modalUrl = 'https://plus.google.com/share?url=' + encodeURIComponent(url);
            window.open(modalUrl, 'googlePlusShareDialog', 'width=' + this.w + ', height=' + this.h + ', top=' + this.top + ', left=' + this.left);
        },
        emailShare : function ( url, title ) {
            var link = 'mailto:?subject=Les på klikk&body=' + encodeURIComponent(title.replace(/%22/g, '"')) + ': ' + encodeURIComponent(url) + '';
            window.open(link, '_top');
        },
        setCount:function(ul){
            var fb = $("a.facebook", ul),
                tw = $("a.twitter", ul),
                url = fb.data("url") || tw.data("url");
            if(!url) {
                if(globals.article)
                    url = globals.article.originalUrl.length > 0 ? globals.article.originalUrl : globals.article.url;
                else if(globals.topic)
                    url = globals.topic.url;
            }

	        if(fb && url){
                var fbElem = $(".count", fb);
                $.ajax({
                    url: "//graph.facebook.com/",
                    data: "id="+url,
	                dataType: 'JSONP',
                    success: function (resp) {
                        if(resp && resp.shares)
                            fbElem.html(resp.shares);
                        else
                            fbElem.html("0");
                    }
                });
            }

            if(tw && url){
                var twElem=$(".count", tw);
                $.ajax({
                    url: "//cdn.api.twitter.com/1/urls/count.json",
                    data: "url="+url,
                    type: 'GET',
                    dataType: 'JSONP',
                    success: function (resp) {
                        if(resp && resp.count)
                            twElem.html(resp.count);
                        else
                            twElem.html("0");
                    }
                });
            }
        }
    }

    fn.video = {
        init: function(){
            if(!this.inited) {
                $(document).on("click", ".video_start", function (e) {
                    e.preventDefault();
                    fn.video.start(this);
                });
            }
            this.inited = true;
        },
	    initMobile: function( id, count ){
		    DrVideo.API.play(
			    id,
			    "video" + count,
			    {
				    custom: {
					    vpCategory: klikk.getGlobal('ads.videoCategory'),
					    vpTags: 'mobile',
					    autoplay: false
				    }
			    }
		    );
		    if(!this.inited) {
			    $(document).on("click", ".video_start", function (e) {
				    e.preventDefault();
				    var videoContainer = $(this).closest(".videoContainer");
				    videoContainer.find(".video").css("width", videoContainer.width());
				    videoContainer.find(".videoTeaser, .pictureCaption").hide();
				    videoContainer.find(".video").show().children()[0].play();
			    });
		    }
		    this.inited = true;
	    },
        start: function(that){
            var videoContainer = $(that).closest(".videoContainer");
            videoContainer.find(".video").css("width", videoContainer.width());
            videoContainer.find(".videoTeaser, .pictureCaption").hide();
            videoContainer.find(".video").toggle();

            DrVideo.API.play(
                videoContainer.data("videoid"),
                    "video" + videoContainer.data("videocount"),
                {
                    'custom': {
                        'vpCategory': klikk.getGlobal('ads.videoCategory'),
                        'vpTags': 'web'
                    }
                }
            );
        }
    }

    fn.image = {
        fullView: {
            init: function() {
                if (!this.inited) {
                    this.inited = true;
                    $(function () {
                        $(".klikk_pictureFullView").click(function (e) {
	                        e.preventDefault();
                            e.stopPropagation();
                            fn.image.fullView.createDialog($(this).parent().find("img"));
                        });
                    });
                }
            },
            createDialog: function(img){
                var clone = $('<img />');
                clone.attr('src', img.closest("[data-imageoriginal]").data("imageoriginal"));

	            var dialog = $('<div />').append(clone).dialog({
                    autoOpen: false,
                    closeOnEscape: true,
                    closeText: 'Lukk',
                    draggable: true,
                    modal: true,
                    resizable: false,
                    width: 'auto',
                    hide: {
                        easing: 'easeInOutCubic',
                        duration: 300,
                        effect: 'fade'
                    },

	                open: function () {

		                var widget = dialog.dialog('widget').css(
			                {
				                'max-height':$(window).height(),
				                'max-width':$(window).width(),
				                top: $(window).scrollTop()
			                }
		                )
		                widget.find('img').load(function(){
			                var container = widget.find('.ui-dialog-content').css(
				                {
					                'height': (widget.innerHeight() - widget.find('.ui-dialog-titlebar').outerHeight()) + 'px',
					                'text-align':'center',
					                overflow: 'hidden'
				                }
			                );

			                var imageAspectRatio = $(this).width() / $(this).height();
			                var containerAspectRatio = container.width() / container.height();
			                if ( containerAspectRatio > imageAspectRatio ) {
				                $(this).css({height:'100%', width:'auto'});
			                } else {
				                $(this).css({height:'auto', width:container.innerWidth()-80});
                                container.css({
                                   maxHeight: $(this).height() + $('.ui-dialog-titlebar').height() + 45
                                });
			                }
                            widget.css({
                                left: ($(window).width() / 2) - (container.outerWidth() / 2)
                            });
		                });

                        // navigating between images within dialog popup
                        var sliderImgContainer = $('.module-gallery-slides');
                        var modalNavButtons = $('<a href="#" class="modal-nav prev"></a> <a href="#" class="modal-nav next"></a>')
                        var imgContainer = widget.find('.ui-dialog-content');
                        widget.append(modalNavButtons);
                        var getCurrentImg = function() {
                            var modalImg = imgContainer.find('img');
                            var modalImgPath = modalImg.attr('src');
                            var currentImgInSlider = sliderImgContainer.find('li[data-imageoriginal="' + modalImgPath + '"]').find('img');
                            return currentImgInSlider;
                        };

                        var checkPrevNext = function(currentImgInSlider) {
                            var isPrevSlide = currentImgInSlider.parent().parent().prev().length > 0;
                            var isNextSlide = currentImgInSlider.parent().parent().next().length > 0;
                            isNextSlide ? $('.modal-nav.next').show() : $('.modal-nav.next').hide();
                            isPrevSlide ? $('.modal-nav.prev').show() : $('.modal-nav.prev').hide();
                        };

                        var centerModal = function() {
                            widget.css({
                                left: ($(window).width() / 2) - (imgContainer.outerWidth() / 2)
                            });
                        };

                        widget.find('.modal-nav').on('click', function(e) {
                            e.preventDefault();
                            var currentImgInSlider = getCurrentImg();

                            if ($(this).hasClass('prev')) {
                                var nextImgPath = currentImgInSlider.parent().parent().prev().attr('data-imageoriginal');
                            } else {
                                var nextImgPath = currentImgInSlider.parent().parent().next().attr('data-imageoriginal');
                            };

                            imgContainer.find('img').fadeOut(200, function () {
                                imgContainer.empty();
                                imgContainer.append($('<img/>').attr('src', nextImgPath).css('maxWidth', '100%').hide());
                                imgContainer.find('img').fadeIn(200, function() {
                                    var newImg = imgContainer.find('img');
                                    newImg.css('maxHeight', $(window).height() - 140);
                                    newImg.css('maxWidth', $(window).width() - 100);

                                    imgContainer.width(newImg.width());
                                    imgContainer.height(newImg.height());
                                    imgContainer.css({
                                        maxHeight:  $(window).height(),
                                        maxWidth:  $(window).width()
                                    });

                                    centerModal();
                                    checkPrevNext(getCurrentImg());
                                });
                            });
                            centerModal();

                        });

                        checkPrevNext(getCurrentImg());
	                },
                    close: function(){
                        dialog.dialog('destroy').remove();
                    }
                });
                dialog.dialog('open');

            }
        },
	    fullscreenView: {
		    init: function() {
			    if (!this.inited) {
				    this.inited = true;
				    $(function () {
					    $(".klikk_pictureFullView").click(function (e) {
						    e.preventDefault();
						    e.stopPropagation();
						    fn.image.fullscreenView.createDialog($(this).parent().find("img"));
					    });
				    });
			    }
		    },
		    createDialog: function ( img ) {
			    var clone = $('<img />');
			    clone.attr('src', img.closest("[data-imageoriginal]").data("imageoriginal"));
			    var dialog = $('<div />').append(clone).dialog({
				    autoOpen: false,
				    closeOnEscape: true,
				    closeText: 'Lukk',
				    draggable: false,
				    modal: true,
				    resizable: false,
				    width: $(window).width(),
				    height: $(window).height(),
				    show: {
					    easing: 'easeInOutCubic',
					    duration: 300,
					    effect: 'fade'
				    },
				    hide: {
					    easing: 'easeInOutCubic',
					    duration: 300,
					    effect: 'fade'
				    },
				    open: function () {
					    dialog.dialog('widget').css({
						    top: 0,
						    left: 0,
						    width: '100%',
						    height: '100%'
					    });
					    $('<span/>').addClass('dialogClose').append( $('<span/>').addClass('icon-diamond')).append($('<span/>').addClass('icon-minus')).click(function(){dialog.dialog('close')}).appendTo(dialog.dialog('widget'));
					    $('.ui-dialog-content img', dialog.dialog('widget')).click(function(){dialog.dialog('close')});
					    klikk.fn.image.fullscreenView.scaleToFit($('.ui-dialog-content img', dialog.dialog('widget')), $('.ui-dialog-content', dialog.dialog('widget')));
					    $('body').addClass('dialogOpen');
				    },
				    close: function(){
					    $('body').removeClass('dialogOpen');
					    dialog.dialog('destroy').remove();
				    }
			    });
			    dialog.dialog('open');
		    },
			scaleToFit: function ( image, imageContainer ) {
				var containerAspectRatio = imageContainer.width() / imageContainer.height();
				var imageAspectRatio = image.width() / image.height();

				if ( containerAspectRatio < imageAspectRatio ) {
					image.css('width', '100%');
					image.css('height', 'auto');
				} else {
					image.css('width', 'auto');
					image.css('height', '100%');
				}
			}

	    }
    }

    fn.cookie = {
        setCookie: function(name, value, hours){
            var cookie = fn.cookie.getCookie(name);
            if(typeof value === "object"){
                if(typeof cookie === "object"){
                    cookie.push(value[0]);
                    cookie = cookie.join("|");
                }else{
                    if(cookie.length > 0)
                        cookie = cookie + "|" + value;
                    else
                        cookie = value;
                }
            }else{
                cookie = value;
            }
            var d = new Date();
            d.setTime(d.getTime()+((hours || 24)*60*60*1000));
            var expires = "expires="+d.toGMTString();
            var host = window.location.hostname.split(".");
            if(host.length > 1)
                host.shift();
            if(host.length > 1){
                host = host.join(".");
                document.cookie = name + "=" + escape(cookie) + "; " + expires + "; domain=" + host + "; path=/;";
            }else{
                document.cookie = name + "=" + escape(cookie) + "; " + expires + "; path=/;";
            }
        },
        getCookie: function(name){
            var name = name + "=";
            var ca = unescape(document.cookie).split(';');
            for(var i=0; i<ca.length; i++){
                var c = ca[i].trim();
                if (c.indexOf(name)==0){
                    var value =  c.substring(name.length,c.length);
                    if(value.indexOf("|") > -1)
                        return value.split("|");
                    else
                        return value;
                }
            }
            return "";
        },
        removeCookie: function(name){
            var host = window.location.hostname.split(".");
            if(host.length > 1)
                host.shift();
            host = host.join(".");
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + host + "; path=/;";
        }
    }

    fn.social = {
        init: function(){
            if(!globals.social.gettingUserData) {
                globals.social.gettingUserData = true;
                var cookie = fn.cookie.getCookie("ks_user");
                if($.isEmptyObject(cookie)){
                    $.when(fn.social.getUser()).then(function(json){
                        if($.isEmptyObject(json)){
                            globals.social.user = {empty: true};
                            fn.cookie.setCookie("ks_user", JSON.stringify({empty: true}), 168);
                        }
                        else{
                            globals.social.user = json;
                            fn.cookie.setCookie("ks_user", JSON.stringify(json), 1);
                        }
                        globals.defer.resolve();
                    });
                }else{
                    globals.social.user = JSON.parse(cookie);
                    globals.defer.resolve();
                }
            }
            $.when(globals.defer).then(function() {
                fn.social.createUserMenu();
            });
        },
        getUser: function(){
            return $.ajax({
                url: globals.ajaxProfileUrl,
                data: {
                    ajax: true
                },
                crossDomain:true,
                jsonpCallback: "klikkSocialCallback",
                contentType: "application/json",
                dataType: 'jsonp',
                xhrFields:{
                    withCredentials:true
                },
                beforeSend: function(xhr, opts){
                    xhr.setRequestHeader('X-Source','KlikkSocial');
                }
            });
        },
        createUserMenu: function(){
            if($.isEmptyObject(globals.social.user) || globals.social.user.empty){
                $(".ks_userMenuContainer .out").toggleClass("hide");
            } else{
                $(".ks_userMenuContainer .ks_avatar").attr({
                    src: globals.social.user.profilePicture,
                    alt: globals.social.user.name,
                    title: globals.social.user.name
                });
                $(".ks_userMenuContainer .in").toggleClass("hide");
            }
        }
    }



    fn.ads = {

        dfpBatchLoading : function(batch, positions, adId, buffer){



            if(!globals.scrollCallbacks.length)
                scroll();

            var triggerAd;
            var findTriggerAd = function(){
                $(positions.join()).each(function() {
                    if(!triggerAd || triggerAd.offset().top > $(this).offset().top)
                        triggerAd = $(this);
                });
                $(".js-expand").unbind("click", findTriggerAd);
            }
            findTriggerAd();
            $(function(){
                $(".js-expand").bind("click", findTriggerAd);
            });

            globals.scrollCallbacks.push(
                function batchLoading(offset, direction, i){
                    if($(adId).offset() != undefined) {
                        var triggerpoint = parseInt($(adId).offset().top) - parseInt(buffer);
                        var bottom_window = $(window).scrollTop() + $(window).height();

                        if (triggerAd.length > 0 && triggerpoint < bottom_window) {
                            googletag.cmd.push(function () {
                                googletag.pubads().refresh(batch, {changeCorrelator: false});

                            });
                            console.log("adId: " + adId +  " loads at " + triggerpoint);
                            globals.scrollCallbacks.splice(i, 1);


                        }
                    }
                }
            );
        },

        batchLoading : function(batch, positions, adId, buffer){



            if(!globals.scrollCallbacks.length)
                scroll();

            var triggerAd;
            var findTriggerAd = function(){
                $(positions.join()).each(function() {
                    if(!triggerAd || triggerAd.offset().top > $(this).offset().top)
                        triggerAd = $(this);
                });
                $(".js-expand").unbind("click", findTriggerAd);
            }
            findTriggerAd();
            $(function(){
                $(".js-expand").bind("click", findTriggerAd);
            });

            globals.scrollCallbacks.push(
                function batchLoading(offset, direction, i){
                    if($(adId).offset() != undefined) {
                        var triggerpoint = parseInt($(adId).offset().top) - parseInt(buffer);
                        var bottom_window = $(window).scrollTop() + $(window).height();

                        if (triggerAd.length > 0 && triggerpoint < bottom_window) {
                            googletag.cmd.push(function () {
                                googletag.pubads().refresh(batch, {changeCorrelator: false});

                            });
                            console.log("adId: " + adId +  " loads at " + triggerpoint);
                            globals.scrollCallbacks.splice(i, 1);


                        }
                    }
                }
            );
        },

        adtechBatchLoading : function(adId, section, suffix, buffer, loaded ){


            //loaded = false;

            if(!globals.scrollCallbacks.length)
                scroll();



            globals.scrollCallbacks.push(
                function adtechBatchLoading(){
                    var triggerpoint = parseInt($("#" + section + "_" + adId).offset().top) - parseInt(buffer);
                    var bottom_window = $(window).scrollTop() + $(window).height();
                    if(parseInt(triggerpoint) < 0){triggerpoint = 0;}

                    if(triggerpoint < bottom_window && !loaded) {

                        ADTECH.enqueueAd( window.enr_appendTargeting ? window.enr_appendTargeting(section + "_" + adId + suffix) : section + "_" + adId + suffix);
                        ADTECH.executeQueue();



                        loaded = true;
                        console.log("adId: " + adId +  " loads at " + triggerpoint);

                    }
                    // var placement = parseInt($(adId).offset().top);

                }
            );


        }
    }




    fn.sticky = {
        share: {
            init: function(){
                if(!globals.scrollCallbacks.length)
                    scroll();
                $(function(){
                    var stick = 1;
                    var stickyShare = $("[data-action=stickyShare]");
                    var container = stickyShare.closest(".row");
                    stickyShare.parent().height(container.height());
                    var topMargin = stickyShare.data("offsettop") || 0;
                    var stopTop = container.offset().top - topMargin;
                    var stopBottom = (container.offset().top + container.height()) - (topMargin + 124);
                    globals.scrollCallbacks.push(
                        function(offsetTop){
                            if(stick != 2 && offsetTop > stopTop && !(offsetTop  > stopBottom)){
                                stickyShare.css({
                                    position: "fixed",
                                    top: topMargin
                                });
                                stick = 2;
                            }else if(stick != 3 && offsetTop > stopBottom) {
                                stickyShare.css({
                                    position: "absolute",
                                    bottom: 0,
                                    top: ""
                                });
                                stick = 3;
                            }else if(stick != 1 && offsetTop < stopTop){
                                stickyShare.css({
                                    position: "relative",
                                    top: 0
                                });
                                stick = 1;
                            }
                        }
                    )

                    // Update position values when async ads are loaded
                    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
                    if(typeof MutationObserver !== 'undefined'){
                        var observer = new MutationObserver(function(mutations, observerOpt) {
                            stopTop = container.offset().top - topMargin;
                            stopBottom = (container.offset().top + container.height()) - (topMargin + 124);
                            $(window).scroll();
                        });
                        var observeItem = document.getElementById("topAdContainer");
                        if(observeItem){
                            observer.observe(observeItem, {
                                subtree: true,
                                attributes: true
                            });
                        }
                    } else{ // Fallback if MutationObserver (prefered) is not supported
                        $(document).on("DOMNodeInserted", "#topAdContainer", function(){
                            stopTop = stickyShare.offset().top - topMargin;
                            stopBottom = (container.offset().top + container.height()) - (topMargin + 124);
                            $(window).scroll();
                        });
                    }
                });
            }
        },
        ads: {
            init: function(){

                if(!globals.scrollCallbacks.length)
                    scroll();
                if(!this.inited) {
                    this.inited = true;
                    var sticky = $(".klikk_sticky");
                    var stick = 1;
                    var stopTop = sticky.offset().top;
                    globals.scrollCallbacks.push(
                        function(offsetTop) {
                            if($(".has-horseshoe").length == 0){
                                if(typeof($(".article.container.story").offset()) !== "undefined") {
                                    stopTop = $(".article.container.story").offset().top;
                                }
                                if(typeof($(".container.section").offset()) !== "undefined"){
                                    stopTop = $(".container.section").offset().top;
                                }
                            }else{
                                stopTop = 1015;
                            }
                            if (sticky) {
                                if (stick != 2 && offsetTop > stopTop) {
                                    sticky.css({
                                        position: "fixed",
                                        top: 0
                                    });
                                    stick = 2;
                                } else if (stick != 1 && offsetTop < stopTop) {
                                    sticky.css({
                                        position: "absolute",
                                        top: stopTop
                                    });
                                    stick = 1;
                                }
                            }
                        }
                    );
                }
            },
            setStickyPosition: function() {

                var sticky = $(".klikk_sticky");
                var horseshoe = false;

                if($(".has-horseshoe").length > 0){
                    sticky.css({
                        position: "absolute",
                        top: 1015
                    });
                    horseshoe = true;
                }
                else {
                    sticky.css({
                        position: "absolute",
                        top: 300
                    });
                    var count = 0;
                    if(!horseshoe) {
                        (function w4hh() {
                            if ($(".has-horseshoe").length > 0) {
                                sticky.css({
                                    top: 1015,
                                    position: "absolute"
                                });
                                horseshoe = true;
                            } else {
                                if (count < 15 && !horseshoe) {
                                    count++;
                                    if(count < 1) {
                                        if (typeof($(".article.container.story").offset()) !== "undefined")
                                            sticky.css({
                                                top: $(".article.container.story").offset().top,
                                                position: "absolute"
                                            });
                                        if (typeof($(".container.section").offset()) !== "undefined")
                                            sticky.css({
                                                top: $(".container.section").offset().top,
                                                position: "absolute"
                                            });
                                    }

                                }
                                setTimeout(w4hh, 500);
                            }
                        })();
                    }
                }
            }


        },
        topMenu: {
            init: function () {
                if(!globals.scrollCallbacks.length)
                    scroll();
                if(!this.inited) {
                    this.inited = true;

                    var sticky = $("nav.navbar:first");
                    var stick = 1;
                    var stopTop = sticky.offset().top;
                    var shareBar = $('.stickyShareBar:first');
                    var logoDiv = $('.navbar-header .logo');
                    var menuButton = $('.navbar-default .navbar-toggle');

                    globals.scrollCallbacks.push(
                        function(offsetTop, direction) {
                            if ( sticky.length > 0 ) {
                                if ( sticky.css('position') != 'fixed' ) {
                                    stopTop = sticky.offset().top; //TODO: Should find a better solution to ad load issue?
                                }
                                if (stick != 2 && offsetTop > stopTop) {
                                    sticky.addClass('sticky');
                                    stick = 2;
                                } else if (stick != 1 && offsetTop < stopTop) {
                                    sticky.removeClass('sticky');
                                    stick = 1;
                                }
                                if ( shareBar.length > 0 ) {
                                    if ( offsetTop > stopTop ) {
                                        if ( direction == 'down' && shareBar.css('display') != 'block' ) {
                                            logoDiv.fadeTo(200, 0, function(){
                                                shareBar.fadeIn(200);
                                                menuButton.attr('style', 'color: #999 !important;');
                                            });
                                        } else if ( direction == 'up' && shareBar.css('display') == 'block') {
                                            shareBar.fadeOut(200, function(){
                                                logoDiv.fadeTo(300,1);
                                                menuButton.removeAttr('style');
                                            });
                                        }
                                    } else if ( shareBar.css('display') == 'block' ) {
                                        shareBar.hide();
                                        logoDiv.show();
                                        menuButton.removeAttr('style');
                                    }
                                }
                            }
                        }
                    );
                }
            }
        }
    }

	fn.breadcrumb = {
		init: function() {
			$('.breadcrumb').swipe({
				swipeStatus: function ( event, phase, direction, distance ) {
					if ( phase == 'move' ) {
						var left = 0;
						if ( typeof this.data('left-position') != 'undefined' )
							left = this.data('left-position');
						var maxLeft = 480 - $(this).outerWidth();
						var maxRight = 0;

						if ( direction == 'left' ) {
							left -= distance;
							if ( left < maxLeft )
								left = maxLeft;
						} else if ( direction == 'right' ) {
							left += distance;
							if ( left > maxRight )
								left = maxRight
						}
						$(this).css('left', left + 'px');

					} else if ( phase == 'cancel' || phase == 'end' ) {
						$(this).data('left-position', $(this).position().left);
					}

				}
			});
		}
	}

	fn.mobileMenu = {
        init: function() {
        	var bodyPosition = 0;
            $('#toggle-main-menu').sidr({
                name: 'main-menu',
                side: 'left',
                source: '#sidr',
                renaming: false,
                displace: false,
                onOpen: function () {
                    bodyPosition = $("body").scrollTop();
                    $('body').css({
                        position: 'fixed',
                        top: '-' + $("body").scrollTop() + 'px'
                    });
                    $(".navbar-default").addClass("menuOpen").append(
                    	$("<a class='closeSidrMenu icon-plus'></a>").click(function(){
                    		$.sidr('close', 'main-menu');
                    		$(this).remove();
                    	})
                    );
                },
                onClose: function () {
                    $('body, .navbar-default:first').removeAttr('style');
                    $("body").scrollTop(bodyPosition);
                    $(".navbar-default:first").removeClass("menuOpen");
                }
            });
            $('#sidr .navbar-nav').remove();
            $('.navbar-default .expand').click(function(){
                $.sidr('toggle', 'main-menu');
                $('#header-search-form input[type=text]').focus();
            });
            $('.sidr-inner').on('click', '.navbar-nav .dropdown .icon-down, .navbar-nav .dropdown .icon-up', function(){
                klikk.fn.mobileMenu.toggleMenuDropdown($(this));
            });
            var moveItem = $(".nav.navbar-nav li.active");
            if ( moveItem ) {
                moveItem.prependTo(moveItem.parent());
            }
            $('#main-menu').swipe({
                threshold: 30,
                excludedElements: 'button, input, select, textarea, .noSwipe',
                swipeLeft: function ( event, direction, distance, duration, fingerCount ) {
                    $.sidr('close', 'main-menu');
                    $(".closeSidrMenu").remove();
                }
            });

        },
        toggleMenuDropdown: function ( anchor ) {
            var list = anchor.siblings('ul:first');
            if ( list.css('display') == 'none' ) {
                list.slideDown();
                anchor.css('display','none').siblings('.icon-up:first').css('display','inline-block');
            } else {
                list.slideUp();
                anchor.css('display','none').siblings('.icon-down:first').css('display','inline-block');
            }
        }
    }

	fn.mobileSearchForm = {
		init: function () {
            $('#header-search-form .icon-search').click(function(){
                $('#header-search-form').submit();
            });
            $('#header-search-form .icon-cancel').click(function(){
                $(this).parent().find('input[type=text]:first').val('');
            });
            $('#header-search-form input[type=text]').focus(function(){
                $(this).parent().addClass('focus');
            });
            $('#header-search-form input[type=text]').blur(function(){
                $(this).parent().removeClass('focus');
            });
		}
	}

	fn.embedly = {
		run: function () {
			if ( klikk.getGlobal('publication.context') == 'art' ) {
				var embedlyKey = klikk.getGlobal('publication.embedlyKey');
				if ( embedlyKey ) {
					var embedlyTargets = /((https?:\/\/(www\.flickr\.com\/photos\/.*|flic\.kr\/.*|twitpic\.com\/.*|www\.twitpic\.com\/.*|twitpic\.com\/photos\/.*|www\.twitpic\.com\/photos\/.*|picasaweb\.google\.com.*\/.*\/.*#.*|picasaweb\.google\.com.*\/lh\/photo\/.*|picasaweb\.google\.com.*\/.*\/.*|instagr\.am\/p\/.*|instagram\.com\/p\/.*|www\.slideshare\.net\/.*\/.*|www\.slideshare\.net\/mobile\/.*\/.*|slidesha\.re\/.*|scribd\.com\/doc\/.*|www\.scribd\.com\/doc\/.*|scribd\.com\/mobile\/documents\/.*|www\.scribd\.com\/mobile\/documents\/.*|polldaddy\.com\/community\/poll\/.*|polldaddy\.com\/poll\/.*|answers\.polldaddy\.com\/poll\/.*|maps\.google\.com\/maps\?.*|maps\.google\.com\/\?.*|maps\.google\.com\/maps\/ms\?.*|storify\.com\/.*\/.*|www\.wikimedia\.org\/wiki\/File.*|.*amazon\..*\/gp\/product\/.*|.*amazon\..*\/.*\/dp\/.*|.*amazon\..*\/dp\/.*|.*amazon\..*\/o\/ASIN\/.*|.*amazon\..*\/gp\/offer-listing\/.*|.*amazon\..*\/.*\/ASIN\/.*|.*amazon\..*\/gp\/product\/images\/.*|.*amazon\..*\/gp\/aw\/d\/.*|www\.amzn\.com\/.*|amzn\.com\/.*|itunes\.apple\.com\/.*|.*youtube\.com\/watch.*|.*\.youtube\.com\/v\/.*|youtu\.be\/.*|.*\.youtube\.com\/user\/.*|.*\.youtube\.com\/.*#.*\/.*|m\.youtube\.com\/watch.*|m\.youtube\.com\/index.*|.*\.youtube\.com\/profile.*|.*\.youtube\.com\/view_play_list.*|.*\.youtube\.com\/playlist.*|www\.ustream\.tv\/recorded\/.*|www\.ustream\.tv\/channel\/.*|www\.ustream\.tv\/.*|ustre\.am\/.*|video\.google\.com\/videoplay\?.*|www\.vimeo\.com\/groups\/.*\/videos\/.*|www\.vimeo\.com\/.*|vimeo\.com\/groups\/.*\/videos\/.*|vimeo\.com\/.*|vimeo\.com\/m\/#\/.*|player\.vimeo\.com\/.*|www\.facebook\.com\/photo\.php.*|www\.facebook\.com\/video\/video\.php.*|www\.facebook\.com\/v\/.*|plus\.google\.com\/.*|www\.google\.com\/profiles\/.*|google\.com\/profiles\/.*|soundcloud\.com\/.*|soundcloud\.com\/.*\/.*|soundcloud\.com\/.*\/sets\/.*|soundcloud\.com\/groups\/.*|snd\.sc\/.*))|(https:\/\/(picasaweb\.google\.com.*\/.*\/.*#.*|picasaweb\.google\.com.*\/lh\/photo\/.*|picasaweb\.google\.com.*\/.*\/.*|itunes\.apple\.com\/.*|.*youtube\.com\/watch.*|.*\.youtube\.com\/v\/.*|www\.vimeo\.com\/.*|vimeo\.com\/.*|player\.vimeo\.com\/.*|www\.facebook\.com\/photo\.php.*|www\.facebook\.com\/video\/video\.php.*|www\.facebook\.com\/v\/.*|plus\.google\.com\/.*)))/i;
					var width = '540';
					if ( klikk.getGlobal('publication.device') == 'mobile' ) {
						width = '460';
					}
					$('.bodyField a').each(function() {
						var link = this.href;
						if(link && embedlyTargets.test(link)) {
							$(this).embedly({
								key: embedlyKey,
								query: {
									maxwidth: width
								}
							});
						}
					});
				}
			}

		}
	}

	fn.tableSwipeIndicator = {
		init: function(){
			$('.bodyField table tbody')
			.filter(function() {
				return $(this).width() > 460;
			})
			.append("<tr class='swipeIndicatorContainer'><td class='swipeIndicator'></td><td class='text'>Sveip til venstre</td></tr>")
			.closest("table")
			.wrap("<div class='swipeTable'></div>")
			.bind('touchstart click', function(){
				var _this = this;
				setTimeout(function(){
					$(_this).find(".swipeIndicatorContainer").fadeOut(300, function(){
						$(this).remove();
					});
				}, 500);
			});
		}
	}

    fn.copyHTML = {
        init: function(){
            var copyWrap = $('<div id="copy-widget" />');
            $('<a href="#" />').text('Lukk vindu').addClass("close").appendTo(copyWrap);
            $('<a href="#" />').text('Vis body-felter').appendTo(copyWrap);
            var bodiesContainer = $('<textarea />').hide().appendTo(copyWrap);
            $('<a href="#" />').text('Vis alt samlet').appendTo(copyWrap);
            var allContainer = $('<textarea />').hide().appendTo(copyWrap);

            copyWrap.dialog({
                autoOpen: false,
                modal: true,
                width: 900
            });

            $(window).keydown(function(event) {
                if(event.ctrlKey && event.altKey && event.keyCode == 67) {
                    event.preventDefault();
                    copyWrap.dialog('open');
                }
            });

            $("#copy-widget a").click(function(e){
                e.preventDefault();
                var that = $(this);
                if(that.hasClass("close"))
                    copyWrap.dialog('close');
                else {
                    that.parent().find("textarea:visible").hide();
                    that.next().show();
                }
            });

            copyWrap.on('click', 'textarea', function() {
                $(this).select();
            });

            var bodies = $(".article .bodyField, .article .readAlso");
            var bodiesHTML = '';
            bodies.each(function() {
                bodiesHTML += this.outerHTML;
            });
            bodiesContainer.text('<div>' + bodiesHTML + '</div>');

            var all = bodies.add($(".collectionArticles"));
            var allHTML = '';
            all.each(function() {
                allHTML += this.outerHTML;
            });
            allContainer.text('<div>' + allHTML + '</div>');
        }
    }

    fn.formJuice = {
        changePlaceholder: function(field, data){
            var i = 0;
            var timer;
            var changePlaceholder = function () {
                timer = setTimeout(function () {
                    var j = 0;
                    var printLetter = function () {
                        setTimeout(function () {
                            field.attr("placeholder", field.attr("placeholder") + data[i].charAt(j));
                            j++;
                            if (j < data[i].length)
                                printLetter();
                            else {
                                i++;
                                if (i < data.length)
                                    changePlaceholder();
                            }
                        }, 50);
                    }
                    field.attr("placeholder", "");
                    printLetter();
                }, 5000);
            }

            changePlaceholder(i);

            field.focus(function () {
                clearTimeout(timer);
            });
        }
    }

    var scroll = function(callback){
        if(!this.inited) {
            this.inited = true;
            var lastScrollTop = 0, lastScrollTime = new Date().getTime();
            $(window).scroll(function () {
                var scrollTop = $(window).scrollTop();
                var scrollTime = new Date().getTime();
                var direction = 'none';
                if ( (scrollTime - lastScrollTime) > 200 ) {
                    if (scrollTop > lastScrollTop) {
                        direction = 'down';
                    } else if (scrollTop < lastScrollTop) {
                        direction = 'up';
                    }
                    lastScrollTime = scrollTime;
                }
                lastScrollTop = scrollTop;

                for(var i = 0; i < globals.scrollCallbacks.length; i++)
                    globals.scrollCallbacks[i](scrollTop, direction, i);
            });
        }
    }

    var run = function(a){ /* Run init functions and event handlers */
        for(var i = 0; i < arguments[0].length; i++){
            try {
                eval(arguments[0][i]+"()");
            } catch(err){
                console.warn("Function with name " + arguments[0][i] + " does not exist");
            }
        }
    };

    var parseToJson = function(obj){
        for(var key in obj){
            if(typeof obj[key] == "object")
                parseToJson(obj[key]);
        }
        return obj;
    };

    return { /* Global functions object */
//        fnc: function(){ // fnc replaced by fn
//            run(arguments);
//        },
        getGlobal: function(name){
            if(name.indexOf(".") > -1){
                try {
                    var p = globals;
                    $.each(name.split("."), function (i, val) {
                        p = p[val];
                    });
                    return p;
                }catch(err){
                    return;
                }
            } else
                return globals[name];
        },
        getGlobals: globals,
        setGlobal: function(name, value){
            if(typeof name == "object")
                $().extend(true, globals, name);
            else if(typeof value == "object"){
                if(!globals[name]) globals[name] = {};
                $().extend(true, globals[name], parseToJson(value));
            }else{
                try{
                    globals[name] = JSON.parse(value);
                }catch(e){
                    globals[name] = value;
                }
            }
        },
        fn: fn
    }
}(jQuery));

// Auto initiate
$(function(){
	$.support.cors = true; // Fix for IE ajax request
    if($(".klikk_toggleTarget").length) klikk.fn.toggle.init();
	klikk.fn.embedly.run();

	if(klikk.getGlobal('publication.device') == 'mobile')
		klikk.fn.tableSwipeIndicator.init();

    $(".avatar_async").each(function(){
        var that = $(this);
            var url = "//www.gravatar.com/avatar/" + that.data("hash") + "?s=" + that.data("size") + "&d=" + that.data("default");
            that.attr("src", url);
    });

    $("#src-expand").click(function(e){
        e.preventDefault();
        $(this).parent().toggleClass("in").find('input[name=q]').focus();
    });

    $("header ul.nav li a .caret").click(function(e){
        e.preventDefault();
        var li = $(this).closest(".dropdown");
        li.toggleClass("open").siblings(".open").removeClass("open");
    });

    var moveItem = $(".navbar-collapse li.active");
    if(moveItem) {
        moveItem.prependTo(moveItem.parent());
        moveItem.find(".caret").click();
    }

    if(klikk.getGlobal("publication").context === "art")
        klikk.fn.copyHTML.init();

    if(klikk.getGlobal("publication").context === "art") {
        // Matching event added to fn.ads.batchloading to fix loading of ads when article is collapsed
        if($(".multibody").height() < 700) {
        	$(".multibody").closest(".expandContainer").removeClass("expandContainer").find("span.expand.js-expand.multibody").remove();
        } else {
	        $(".js-expand").on("click", function (e) {
	            e.stopPropagation();
	            var $this = $(this);
	            var $container = ($this.hasClass("js-container") ? $this : $this.closest(".js-container"));
	            if (!$this.hasClass("js-container") && $container.is(".on")) {
	                $container.css("max-height", $container.data("initialHeight")).removeClass("on");
	                $container.find(".fade:last").show();
	                $container.find(".expand:last").removeClass("on");
	            } else {
	                if(!$container.data("initialHeight"))
	                    $container.data("initialHeight", $container.outerHeight());
	                $container.css("max-height", "none").addClass("on");
	                $container.find(".fade:last").hide();
	                $container.find(".expand:last").addClass("on");
	            }
	            $this.unbind(e);
	        });
	    }
    }
});
klikk.fn.articleSlideshow = {
    init: function(args){
        var dataName = 'hmi-articleSlideshow',
            selectors = {
                slidebox: '.module-gallery-slides-box',
                slides: '.module-gallery-slides',
                slide: 'li',
                description: '.module-gallery-description-box',
                descriptionContent: '.module-gallery-description',
                descriptionCopyright: '.module-gallery-copyright',
                thumbbox: '.module-gallery-thumbnails-box',
                thumbs: '.module-gallery-thumbnails',
                thumb: 'li',
                fullView: '.module-gallery-full'
            },
            thumbActiveClass = 'gallery-thumb-active',
            defaults = {
                thumbnails: true
            },
            isTouch = 'ontouchstart' in window,
            descriptionBoxClass = 'module-gallery-slide-description',
            descriptionContentClass = 'module-gallery-slide-content',
            prevBtnClass = 'module-gallery-prev module-gallery-nav',
            nextBtnClass = 'module-gallery-next module-gallery-nav',
            fullViewClass = 'module-gallery-full',
            slideIndicatorClass = 'module-gallery-slide-indicator';

        var elements = $('.klikk_slideshow:not(.inited)');
        elements.addClass("inited");

        var iosSlider = $().iosSlider,
            def = $.Deferred(),
            options = $.extend(true, {}, defaults, args),
            script = klikk.getGlobal("publication").baseUrl + 'static/thirdparty/iosSlider/iosSlider.min.js',
            hmi = $().hmi;

        def.done(function () {
            elements.each(function () {
                var _this = $(this),
                    data = _this.data(dataName);

                if (data) return true;

                var options = $.extend(true, {}, defaults, args);

                _this.data(dataName, options);

                var thumbBox, thumbSlider, thumbs, thumbSliderWidth, boxWidth, startPos, thumbPos, slideChange, slideComplete, thumbSliderLoaded, mousemove,
                    trackMoves = !isTouch,
                    mouseOnThumbs = false,
                    activeSlide = 0,
                    slidesBox = $(selectors.slidebox, _this),
                    slider = $(selectors.slides, slidesBox),
                    slides = $(selectors.slide, slider),
                    descriptionBox = $('<div />').addClass(descriptionBoxClass),
                    descriptionContent = $('<div />').addClass(descriptionContentClass).appendTo(descriptionBox),
                    descriptionVisible = false,
                    prevBtn = $('<div />').addClass(prevBtnClass).appendTo(slidesBox),
                    nextBtn = $('<div />').addClass(nextBtnClass).appendTo(slidesBox),
                    fullView = $('<div />').addClass(fullViewClass).appendTo(slidesBox),
                    slideIndicator = $('<div />').addClass(slideIndicatorClass).appendTo(slidesBox);

                descriptionBox.appendTo(_this);


                slides.each(function () {
                    var slide = $(this),
                        image = $('img', slide);

	                var imageAspectRatio = image.width() / image.height();
	                var containerAspectRatio = slide.width() / slide.height();

	                if ( containerAspectRatio > imageAspectRatio ) {
		                image.css({height:'100%'});
		                image.css({width:'auto'});
	                } else {
		                image.css({height:'auto'});
		                image.css({width:'100%'});
		                $('.module-gallery-image', slide).css({
			                'height': slide.height() + 'px',
			                'display': 'table-cell',
			                'vertical-align': 'middle'
		                });

	                }

                });

                fullView.click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();

	                klikk.fn.image.fullView.createDialog(slides.eq(activeSlide).find('img'));

                    //slides.eq(activeSlide).find(selectors.fullView).trigger('click.imageFullView');
                });

                slideComplete = function (args) {
                    var slideDescription,
                        index = args.currentSlideNumber - 1,
                        slide = slides.eq(index),
                        description = $(selectors.descriptionContent, slide);

                    if (description.size()) {
                        slideDescription = $.trim(description.html());
                    }

                    var lefty = thumbSlider.css('left');

                    if (slideDescription) {
                        if (!descriptionVisible) {
                            descriptionVisible = true;
                            descriptionBox.addClass('isopen');
                        }

                        //descriptionCopy.html(slideDescription);

                        //descriptionBox.height(descriptionCopy.outerHeight());

                        descriptionContent.html(slideDescription);

                        thumbSlider.animate({left: lefty}, 0);
                    } else {
                        if (descriptionVisible) {
                            descriptionContent.html('');

                            descriptionBox.height(0).removeClass('isopen');

                            thumbSlider.animate({left: lefty}, 0);

                            descriptionVisible = false;
                        }
                    }

                    if (options.thumbnails && trackMoves) {
                        // Set left for IE8, rendering bug when description height is changed
                        thumbSlider.animate({left: lefty}, 0);
                    }
                };

                slideChange = function (args) {
                    var index = args.currentSlideNumber - 1;

                    if (args.slideChanged && activeSlide == index) {
                        return true;
                    }

                    activeSlide = index;

                    prevBtn.css('display', index == 0 ? 'none' : 'block');
                    nextBtn.css('display', (index >= (args.data.numberOfSlides - 1)) ? 'none' : 'block');

                    if (options.thumbnails) {
                        thumbs.removeClass(thumbActiveClass);

                        var activeThumb = thumbs.eq(index),
                            thumbLeft = activeThumb.position().left,
                            thumbsLeft = thumbSlider.position().left,
                            thumbWidth = activeThumb.width();

                        activeThumb.addClass(thumbActiveClass);

                        if (mouseOnThumbs) {
                            return true;
                        }

                        if ((thumbsLeft + thumbLeft) < 0) {
                            thumbSlider.stop(true, false);
                            thumbBox.iosSlider('goToSlide', index + 1);

                            thumbPos = -thumbs.eq(index).position().left;
                        } else if ((thumbsLeft + thumbLeft + thumbWidth) > boxWidth) {
                            var lookForPoint = thumbLeft + thumbWidth - boxWidth;

                            thumbs.each(function () {
                                var thumb = $(this),
                                    thumbLeft = thumb.position().left;

                                if (thumbLeft >= lookForPoint) {
                                    thumbSlider.stop(true, false);
                                    thumbBox.iosSlider('goToSlide', thumb.index() + 1);

                                    thumbPos = -lookForPoint;

                                    return false;
                                }

                            });
                        }
                    }
                };

                if (options.thumbnails) {
                    var intervalID = 0;

                    thumbBox = $(selectors.thumbbox, _this);
                    thumbSlider = $(selectors.thumbs, thumbBox);
                    thumbs = $(selectors.thumb, thumbSlider);

                    thumbs.each(function () {
                        $(this).append('<div class="after" />');
                    });

                    thumbSliderLoaded = function () {
                        thumbSliderWidth = thumbSlider.width();
                        boxWidth = thumbBox.width();
                        startPos = -thumbSliderWidth;
                        thumbPos = startPos;

                        trackMoves = (thumbSliderWidth > boxWidth) && !isTouch;
                    };

                    thumbBox.iosSlider({
                        snapToChildren: true,
                        onSliderLoaded: thumbSliderLoaded
                    });

                    var thumbImgs = $('img', thumbSlider),
                        thumbCount = thumbImgs.size(),
                        loaded = 0;

                    thumbImgs.each(function () {
                        var _this = $(this);

                        _this.load(function () {
                            if (++loaded >= thumbCount) {
                                thumbBox.iosSlider('update');
                                thumbSliderLoaded();
                            }
                        });

                        if (this.complete) _this.load();
                    });

                    thumbs.click(function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        var item = $(this).index() + 1;

                        slidesBox.iosSlider('goToSlide', item);
                    });

                    thumbSliderWidth = thumbSlider.width();
                    boxWidth = thumbBox.width();
                    startPos = -thumbSliderWidth;
                    thumbPos = startPos;

                    trackMoves = (thumbSliderWidth > boxWidth) && !isTouch;
                    intervalID = 0;

                    if (trackMoves) {
                        var thumbSpeed = 17,
                            cursorPosX = 0,
                            cursorPosY = 0,
                            getDiff = function (diff, speed) {
                                var prefix = diff < 0 ? -1 : 1,
                                    abs = Math.abs(diff);

                                if (abs < speed) {
                                    return abs > 0.5 ? prefix : 0;
                                }

                                return Math.round(diff / speed);
                            },
                            easeCubic = function (frac) {
                                // http://greweb.me/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
                                return frac < 0.5 ? 4 * frac * frac * frac : (frac - 1) * (2 * frac - 2) * (2 * frac - 2) + 1;
                            };

                        mousemove = function () {
                            var left = thumbBox.offset().left,
                                fraction = easeCubic((cursorPosX - left) / boxWidth),
                                pos = thumbSliderWidth * fraction,
                                endPoint = startPos - pos + fraction * boxWidth,
                                diff = endPoint - thumbPos,
                                currentThumb = $(document.elementFromPoint(cursorPosX, cursorPosY));

                            if (!currentThumb.is('li')) {
                                currentThumb = currentThumb.closest('li');
                            }

                            currentThumb.addClass('ishover');
                            thumbs.not(':eq(' + currentThumb.index() + ')').removeClass('ishover');

                            thumbPos = Math.round(thumbPos + getDiff(diff, thumbSpeed));

                            if (!mouseOnThumbs) {
                                // When mousemove is triggered, and mouse is outside thumbnails area
                                // just animate to the final x-position the mouse was at
                                thumbPos = endPoint;

                                thumbSlider.stop(true, false).animate({
                                    left: thumbPos
                                }, thumbSpeed * 20, 'easeOutQuint');

                                clearInterval(intervalID);
                                return true;
                            }

                            if (Math.abs(diff) < 1) {
                                return true;
                            }

                            thumbSlider.stop(true, false).css('left', thumbPos);
                        };
                    }

                    thumbBox.mouseenter(function () {
                        mouseOnThumbs = true;

                        thumbBox.on('mousemove.artSlideshow', function (e) {
                            cursorPosX = e.clientX;
                            cursorPosY = e.clientY;
                        });

                        if (trackMoves) {
                            intervalID = setInterval(mousemove, 10);
                        }
                    }).mouseleave(function () {
                        mouseOnThumbs = false;

                        if (trackMoves) {
                            thumbBox.off('mousemove.artSlideshow');
                        }
                    });
                }
                slidesBox.iosSlider({
                    desktopClickDrag: true,
                    snapToChildren: true,
                    onSlideChange: slideChange,
                    onSliderLoaded: function (args) {
                        slideChange(args);
                        slideComplete(args);
                    },
                    onSlideComplete: slideComplete,
                    onSlideStart: function () {
                        slideIndicator.fadeOut(200);

                        if (options.thumbnails) {
                            thumbs.removeClass('ishover');

                            if (isTouch) {
                                thumbBox.trigger('mouseleave');
                            }
                        }
                    },
                    navPrevSelector: prevBtn,
                    navNextSelector: nextBtn
                });
            });
        });

        if (!iosSlider) {
            $.ajax({
                dataType: 'script',
                cache: true,
                url: script
            }).done(function() {
                def.resolve();
            });
        } else {
            def.resolve();
        }

        return elements;
    }
}



klikk.fn.articleSlideshowMobile = {
	init: function(args){
		var dataName = 'hmi-articleSlideshow',
			elements = $('.klikk_slideshow:not(.inited)');

		elements.addClass("inited");

		var defaults = {

		}
		var def = $.Deferred(),
			options = $.extend(true, {}, defaults, args),
			script = klikk.getGlobal("publication").baseUrl + 'static/thirdparty/iosSlider/iosSlider.min.js',
			hmi = $().hmi;

		var selectors = {
			slidebox: '.module-gallery-slides-box',
			slides: '.module-gallery-slides',
			slide: 'li',
			fullView: '.icon-plus',
			currentSlideNum: '.currentSlideNum'
		}
		var dataName = 'hmi-articleSlideshow',
			prevBtnClass = 'module-gallery-prev icon-back',
			nextBtnClass = 'module-gallery-next icon-forward',
			iosSlider = $().iosSlider;


		def.done(function () {
			elements.each(function () {
				var _this = $(this),
					data = _this.data(dataName);

				if (data) return true;

				var options = $.extend(true, {}, defaults, args);

				_this.data(dataName, options);

				var slidesBox = $(selectors.slidebox, _this),
					slider = $(selectors.slides, slidesBox),
					slides = $(selectors.slide, slider),
					prevBtn = $('<div />').addClass(prevBtnClass).appendTo(slidesBox),
					nextBtn = $('<div />').addClass(nextBtnClass).appendTo(slidesBox),
					fullViewBtn = $(selectors.fullView, _this);

				fullViewBtn.click(function(){
					_this.toggleClass('fullView');
					closeFullViewBtn = $('<span/>').addClass('closeFullView').append($('<span/>').addClass('icon-diamond')).append($('<span/>').addClass('icon-minus')).appendTo(_this);
					closeFullViewBtn.click(function(){
						_this.removeClass('fullView');
						$('.module-gallery-image', slides).css('width', '100%').css('height', '100%');
						slidesBox.iosSlider('update');
						$(this).remove();
					});

					slidesBox.iosSlider('update');
					var img = $('img', slidesBox);
					$('.module-gallery-image', slides).css('width', $(window).width() + 'px').css('height', $(window).height() + 'px');
					imageScaleToFit(img, slides);

					var offsetTop = parseInt($('.module-gallery-image', slides).height()/2 - prevBtn.height()/2) + 'px';
					prevBtn.css('top', offsetTop);
					offsetTop = parseInt($('.module-gallery-image', slides).height()/2 - nextBtn.height()/2) + 'px';
					nextBtn.css('top', offsetTop);
				});


				slideChange = function ( args ) {
					var index = args.currentSlideNumber - 1;
					prevBtn.css('display', index == 0 ? 'none' : 'block');
					nextBtn.css('display', (index >= (args.data.numberOfSlides - 1)) ? 'none' : 'block');
					if ( _this.hasClass('fullView') ) {
						var img = $('img', args.currentSlideObject);
						imageScaleToFit(img, args.currentSlideObject);
					}
				}

				slideComplete = function ( args ) {
					$(selectors.currentSlideNum, _this).html(args.currentSlideNumber);
					if ( ! _this.hasClass('fullView') ) {
						args.sliderContainerObject.animate(
							{
								height: args.currentSlideObject.height() + 'px'
							},
							200,
							'swing',
							updateButtonPosition(args)
						);
					} else {
						updateButtonPosition(args);
					}
				}

				updateButtonPosition = function ( args ) {
					var offsetTop = parseInt($('.module-gallery-image', args.currentSlideObject).height()/2 - prevBtn.height()/2) + 'px';
					prevBtn.css('top', offsetTop);
					offsetTop = parseInt($('.module-gallery-image', args.currentSlideObject).height()/2 - nextBtn.height()/2) + 'px';
					nextBtn.css('top', offsetTop);
				}

				imageScaleToFit = function ( image, imageContainer ) {
					var containerAspectRatio = imageContainer.width() / imageContainer.height();
					var imageAspectRatio = image.width() / image.height();

					if ( containerAspectRatio < imageAspectRatio ) {
						image.css('cssText', 'width: 100% !important');
						image.css('height', 'auto');
					} else {
						image.css('cssText', 'width: auto');
						image.css('height', '100%');
					}
				}

				slidesBox.iosSlider({
					desktopClickDrag: true,
					snapToChildren: true,
					onSlideChange: slideChange,
					onSliderLoaded: function (args) {
						slideChange(args);
						slideComplete(args);
					},
					onSlideComplete: slideComplete,
					onSlideStart: function () {
						//slideIndicator.fadeOut(200);
					},
					navPrevSelector: prevBtn,
					navNextSelector: nextBtn

				});
			});
		});

		if (!iosSlider) {
			$.ajax({
				dataType: 'script',
				cache: true,
				url: script
			}).done(function() {
				def.resolve();
			});
		} else {
			def.resolve();
		}

		return elements;
	}
}



$.fn.teaserSlider = function ( options ) {
	var $app = this;
	$app.addClass('inited');
	$app.settings = $.extend({
		selectors: {
			slider: '.iosslider',
			leftButton: '.slideLeft',
			rightButton: '.slideRight'
		},
		iosSliderOptions: {
			desktopClickDrag: true,
			snapToChildren: true,
			responsiveSlides: false,
			onSlideComplete: function ( args ) {
				$app.slideComplete(args);
			}
		},
		slideButtonSteps: 1
	}, options );

	$app.slider = $($app.settings.selectors.slider, $app);
	$app.slider.data('currentSlide', 1);
	$app.slideLeftButton = $($app.settings.selectors.leftButton, $app);
	$app.slideRightButton = $($app.settings.selectors.rightButton, $app);

	var iosSlider = $().iosSlider;
	var	def = $.Deferred();
	var	script = klikk.getGlobal("publication").baseUrl + 'static/thirdparty/iosSlider/iosSlider.min.js';

	$app.adjustSliderHeight = function () {
		var innerHeight = 0;
		var outerHeight = 0;
		var sliders = $app.slider.find('.slide');
		sliders.each(function(){
			var _this = $(this);
			var slideOuterHeight = _this.outerHeight();
			if ( slideOuterHeight > outerHeight ) {
				outerHeight = slideOuterHeight;
				innerHeight = slideOuterHeight - parseInt(_this.css('padding-top')) - parseInt(_this.css('padding-bottom'));
			}
		});
		sliders.height(innerHeight);
		$app.slider.height(outerHeight);
	}

	$app.slideButtonClick = function ( args ) {
		var direction = args.data.direction;
		var steps = args.data.steps;
		var currentSlide = $app.slider.data('currentSlide');
		var slideTo = 1;
		if ( direction == 'left' ) {
			if ( currentSlide == 1 )
				return;
			slideTo = $app.slider.data('currentSlide') - steps;
			if ( slideTo < 1 )
				slideTo = 1;
		} else {
			var maxRightSlide = $app.slider.data('iosslider').childrenOffsets.length;
			if ( currentSlide == maxRightSlide  )
				return;
			slideTo = $app.slider.data('currentSlide') + steps;
			if ( slideTo > maxRightSlide )
				slideTo = maxRightSlide;
		}
		$app.slider.iosSlider('goToSlide', slideTo);
		$app.slider.data('currentSlide', slideTo);
	}

	$app.slideComplete = function ( args ) {
		if ( args.slideChanged ) {
			if ( args.currentSlideNumber == 1 ) {
				$app.slideLeftButton.removeClass('active');
			} else if ( args.currentSliderOffset == args.data.sliderMax ) {
				$app.slideRightButton.removeClass('active');
			} else {
				$app.slideLeftButton.addClass('active');
				$app.slideRightButton.addClass('active');
			}
			$app.slider.data('currentSlide', args.currentSlideNumber);
		}
	}

	def.done(function () {
		$($app.settings.selectors.slider, $app).iosSlider($app.settings.iosSliderOptions);
		$app.slideLeftButton.click({direction:'left', steps:$app.settings.slideButtonSteps},$app.slideButtonClick);
		$app.slideRightButton.click({direction:'right', steps:$app.settings.slideButtonSteps}, $app.slideButtonClick);
		$app.adjustSliderHeight();
	});

	if (!iosSlider) {
		$.ajax({
			dataType: 'script',
			cache: true,
			url: script
		}).done(function() {
			def.resolve();
		});
	} else {
		def.resolve();
	}
};
var BrightcovePlayer = {
	init: function ( player_id ) {
		var brandName = klikk.getGlobal('section.brand');
		if ( brandName ) {
			videojs(player_id).ready(function () {
				var player = this;
				var playerTag = player.el();
				var overlay = $('.vjs-poster-overlay', playerTag);
				var brand = $('.vjs-video-brand', overlay);
				if ( !brand ) {
					brand = $('p').addClass('vjs-video-brand');
					overlay.prepend(brand);
				} else {
					brand.attr('class', '');
					brand.addClass('vjs-video-brand');
				}
				brand.addClass('klikk-' + brandName);
				overlay.css('margin-top',(-parseInt(overlay[0].offsetHeight/2)));
			});
		}

	}
}
